<template>
  <div
    class="grid grid-cols-12 gap-0 border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 bg-amber-50/30 dark:bg-amber-900/10"
  >
    <!-- Type Column -->
    <div class="col-span-1 py-1 px-2 flex items-center justify-center border-r border-gray-200 dark:border-gray-700">
      <span class="text-amber-500 font-bold">*</span>
    </div>

    <!-- Operation Name Column -->
    <div class="col-span-4 py-1 px-2 flex items-center border-r border-gray-200 dark:border-gray-700 pl-4">
      <span class="truncate flex-grow">{{ subAction.name }}</span>
    </div>

    <!-- Type Tag Column -->
    <div class="col-span-1 py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">
      <Tag
        v-if="subAction.type"
        :value="subAction.type"
        severity="info"
        class="text-xs py-0 px-1"
      />
    </div>

    <!-- Empty Hours Column -->
    <div class="col-span-1 py-1 px-2 border-r border-gray-200 dark:border-gray-700"></div>

    <!-- Financial Cells -->
    <FinancialCell  />
    <FinancialCell  /> <!-- Same value for example -->
    <FinancialCell  /> <!-- Same value for example -->

    <!-- Empty Actions Column -->
    <div class="col-span-1 py-1 px-2"></div>
  </div>
</template>

<script setup lang="ts">
import FinancialCell from './cells/FinancialCell.vue';
import Tag from 'primevue/tag';
interface SubAction {
  name: string;
  type?: string;
  price?: number | string;
}

const props = defineProps<{
  subAction: SubAction;
}>();
</script>
